import {Injectable} from 'ng-metadata/core';

@Injectable()
export class UserAreaExpandableService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/userAreaExpandable.service.ts